import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, Eye } from 'lucide-react';
import { FormSection, Button, DataTable, TableHeader, TableHeaderCell, TableBody, TableRow, TableCell, StatusBadge, EmptyState } from '../../common/ui';
import { formatDate } from '../../../utils/dateUtils';

const RepairsHistorySection = ({ deviceData, repairs = [], loading = false }) => {
  const navigate = useNavigate();

  const handleViewRepair = (repair) => {
    navigate(`/repairs/${repair.id}/view`);
  };

  const handleCreateRepair = () => {
    navigate('/repairs/new', { 
      state: { 
        preselectedDevice: {
          id: deviceData.id,
          serial_number: deviceData.serial_number,
          model: deviceData.model
        }
      }
    });
  };

  const renderActions = () => {
    return (
      <Button
        variant="primary"
        onClick={handleCreateRepair}
        icon={Plus}
        size="xs"
      >
        New Repair
      </Button>
    );
  };

  return (
    <FormSection title="Repairs History" actions={renderActions()}>
      {loading ? (
        <div className="flex items-center justify-center py-8">
          <div className="text-gray-500">Loading repairs history...</div>
        </div>
      ) : repairs.length === 0 ? (
        <EmptyState message="No repairs found for this device" />
      ) : (
        <DataTable>
          <TableHeader>
            <tr>
              <TableHeaderCell>ID</TableHeaderCell>
              <TableHeaderCell>Notes</TableHeaderCell>
              <TableHeaderCell>Status</TableHeaderCell>
              <TableHeaderCell>Reported</TableHeaderCell>
            </tr>
          </TableHeader>
          <TableBody>
            {repairs.map((repair) => (
              <TableRow 
                key={repair.id}
                clickable={true}
                href={`/repairs/${repair.id}/view`}
                onClick={() => handleViewRepair(repair)}
              >
                <TableCell className="font-medium">
                  #{repair.id}
                </TableCell>
                <TableCell className="max-w-xs">
                  <div className="text-sm text-gray-900 truncate">
                    {repair.final_resolution || repair.acceptance_notes || 'No notes provided'}
                  </div>
                </TableCell>
                <TableCell>
                  <StatusBadge status={repair.status} variant="repair" />
                </TableCell>
                <TableCell className="text-gray-500">
                  {repair.reported_date ? formatDate(repair.reported_date) : 'N/A'}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </DataTable>
      )}
    </FormSection>
  );
};

export default RepairsHistorySection;

